import React from 'react'


export default class DropDownItem extends React.Component {

    render(){
        return (
            <a className="dropdown-2--item" onClick={this.props.onClick}>
                <span>{this.props.children || this.props.title}</span>
            </a>
        )
    }

}